/**
 * Pantalla de inicio de sesión con formulario, logo y créditos de financieras.
 */
import React, { useState } from "react";
import { Form, Image, Typography } from "antd";
import { getDeployEnvironment } from "utils/config/getDeployEnvironment";
import { useAuth } from "AuthContext";
import useCurrentIp from "hooks/useCurrentIp";
import POSTLogin from "helpers/usuario/POSTLogin";
import logoPrincipal from "assets/LogoFull.svg";
import logoBlancoPequeño from "assets/Icono_blanco.svg";
import RecoverForm from "views/login/forms/RecoverForm";
import LoginForm from "views/login/forms/LoginForm";
import POSTRecuperarClave from "helpers/auth/POSTRecuperarClave";
import { financierasBanner } from "./financierasBanner";
import "views/login/index.css";

const Login = () => {
  const currentVersion = process.env.REACT_APP_VERSION;
  const [loadings, setLoadings] = useState([]);

  const [loginError, setLoginError] = useState();
  const [recoverResponse, setRecoverResponse] = useState(null);
  const [view, setView] = useState("login");
  const [form] = Form.useForm();
  const [forgotForm] = Form.useForm();
  const { login } = useAuth();

  const { currentIp } = useCurrentIp();

  const enterLoading = (index) => {
    setLoadings((prev) => {
      const arr = [...prev];
      arr[index] = true;
      return arr;
    });
    setTimeout(() => {
      setLoadings((prev) => {
        const arr = [...prev];
        arr[index] = false;
        return arr;
      });
    }, 2800);
  };

  const onFinishForgot = async (values) => {
    const response = await POSTRecuperarClave(values?.username);
    setRecoverResponse(response);
  };

  const handleBackToLogin = () => {
    setView("login");
    forgotForm.resetFields();
    setRecoverResponse(null);
  };

  const onFinish = async (values) => {
    const cleanedValues = {
      usuario: values.user,
      clave: values.password,
      dirIp: currentIp,
      versioNFE: currentVersion || "-",
    };

    const result = await POSTLogin(cleanedValues);
    if (result.status === 200 && result.data.token) {
      setTimeout(() => login(result.data), 2000);
    } else {
      setTimeout(
        () =>
          setLoginError({
            message: result?.data?.resultadoInterface?.mensaje || "Error interno",
          }),
        2000
      );
    }
  };

  const handleForgotPassword = () => {
    setView("forgot");
  };

  return (
    <div className="login-hero-wrapper">
      {/* Hero Branding a la derecha */}
      <div className="hero-section">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "40px",
          }}
          className=" hero-animated"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                lineHeight: "1.1",
                color: "#fff",
                textShadow: "0 2px 8px rgba(0,0,0,0.2)",
              }}
            >
              <div className="hero-text-wrapper">
                <span className="hero-text-line">Tu tiempo</span>
                <span className="hero-text-line">es valioso,</span>
                <span className="hero-text-line">tu gestión también</span>
              </div>
            </div>
            <img src={logoBlancoPequeño} alt="Logo" className="hero-small-logo" />
          </div>

          <p className="hero-subtitle">
            Conectate con todas las financieras que manejás desde un solo lugar y optimizá tu flujo
            de trabajo.
          </p>
        </div>

        {/* Shapes animadas */}
        <div className="hero-shapes">
          {[...Array(8)].map((_, i) => (
            <span key={i}></span>
          ))}
        </div>
      </div>

      <div className="form-section form-animated">
        <div className="form-center-wrapper">
          <div className="onefin-login-form-container">
            <div className="form-logo-wrapper">
              <Image src={logoPrincipal} preview={false} width={250} />
            </div>
            {view === "login" && (
              <>
                <div className="onefin-brand-divider" />
                <Typography.Title level={2} className="onefin-login-welcome">
                  Bienvenido
                </Typography.Title>
              </>
            )}
            {view === "login" ? (
              <LoginForm
                form={form}
                loading={loadings[0]}
                onFinish={onFinish}
                handleForgotPassword={handleForgotPassword}
                onLoading={() => enterLoading(0)}
                loginError={loginError}
                setLoginError={setLoginError}
              />
            ) : (
              <RecoverForm
                form={forgotForm}
                loading={loadings[1]}
                onFinishForgot={onFinishForgot}
                handleBackToLogin={handleBackToLogin}
                onLoading={() => enterLoading(1)}
                recoverResponse={recoverResponse}
              />
            )}

            {/* Banner translúcido con logos */}
            <div className="hero-financieras-banner">
              <div className="logos-wrapper">
                {financierasBanner.map(({ name, logo, url }) => (
                  <a key={name} href={url} target="_blank" rel="noopener noreferrer" title={name}>
                    <img src={logo} alt={name} style={{ cursor: "pointer" }} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="onefin-legal">
          <span className="onefin-legal-link">
            © {new Date().getFullYear()} Innercor Soluciones ERP
          </span>
          <div className="onefin-legal-links">
            <span className="onefin-legal-link">EULA</span>
            <span className="onefin-legal-link">Privacidad</span>
            <span className="onefin-legal-version">
              {currentVersion} {getDeployEnvironment()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
